import './theme.scss';
import './fonts.scss';
import './styles.scss';
import Hammer from 'hammerjs';

// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Autoplay, FreeMode, Navigation, Pagination} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

new Swiper('.marketplace', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 5,
    autoplay: {
        delay: 2500,
        pauseOnMouseEnter: true,
        waitForTransition: true
    },
    // Responsive breakpoints
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 1
        }
    },
    // configure Swiper to use modules
    modules: [Navigation, Pagination, Autoplay]
});

// init Swiper:
new Swiper('.swiper', {
    loop: true,
    slidesPerView: 1,
    freeMode: true,
    spaceBetween: 5,
    autoplay: {
        delay: 4000,
        pauseOnMouseEnter: true,
        waitForTransition: true
    },
    // Responsive breakpoints
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 2,
            spaceBetween: 5
        },
        // when window width is >= 480px
        480: {
            slidesPerView: 3,
            spaceBetween: 5
        },
        // when window width is >= 640px
        640: {
            slidesPerView: 4,
            spaceBetween: 5
        }
    },
    // configure Swiper to use modules
    modules: [Navigation, Pagination, Autoplay, FreeMode]
});

document.addEventListener('DOMContentLoaded', () => {
    const searchBar = document.getElementById('searchbar') as HTMLFormElement;

    if (searchBar) {
        const searchIcon = searchBar.querySelector('.icon');
        searchIcon?.addEventListener('click', () => {
            searchBar?.submit();
        });
    }

    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Add a click event on each of them
    $navbarBurgers.forEach(el => {
        el.addEventListener('click', () => {

            // Get the target from the "data-target" attribute
            const target = el.dataset.target;
            const $target = document.getElementById(target);

            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
            el.classList.toggle('is-active');
            $target!.classList.toggle('is-active');

        });
    });

    // click or tap on languages selector
    const languages = document.querySelector<HTMLElement>('.languages');
    const arrow = languages?.querySelector('.arrow');
    const selectedLang = languages?.querySelector('.is-selected');

    if (languages && arrow && selectedLang) {

        const clickOutsideHandler = (event: Event) => {
            const isClickInside = languages.contains(event.target as Node);
            if (!isClickInside && languages.classList.contains('opened')) {
                languages.classList.remove('opened');
            }
            document.removeEventListener('click', () => {
            });
        };

        const clickHandler = () => {
            languages.classList.toggle('opened');
            if (languages.classList.contains('opened')) {
                document.addEventListener('click', clickOutsideHandler);
            } else {
                document.removeEventListener('click', () => {
                });
            }
        };

        const hammerSelectedLanguage = new Hammer(selectedLang as HTMLElement);
        const hammerArrow = new Hammer(arrow as HTMLElement);
        hammerSelectedLanguage.on('tap', clickHandler);
        hammerArrow.on('tap', clickHandler);

    }

    // click or tap on dropdown menu
    let dropdowns = document.querySelector<HTMLElement>('.dropdown, .right_submenu_li');
    if (dropdowns) {
        const hammer2 = new Hammer(dropdowns);
        hammer2.on('tap', () => dropdowns.classList.toggle('opened'));
    }

    const spravkaItems = document.querySelectorAll<HTMLElement>('.spravka-item');
    spravkaItems.forEach(item => {
        item.addEventListener('click', () => {
            if (item.dataset.link) {
                document.location.href = item.dataset.link;
            }
        });
    });

    const teamMembers = document.querySelectorAll<HTMLElement>('.ourPeople__block');
    teamMembers.forEach(item => {
        new Hammer(item).on('tap', () => {
            item.classList.toggle('active');
        });
    });

    const contactSections = document.querySelectorAll<HTMLElement>('.contact-section');
    if (contactSections && contactSections.length > 0) {
        contactSections.forEach(item => {
            const header = item.querySelector<HTMLElement>('.contact-header');
            if (header) {
                new Hammer(header).on('tap', () => {
                    item.classList.toggle('active');
                });
            }

        });
    }

    const accordions = document.querySelector('.accordion-offices')
    accordions?.addEventListener("click", (e:Event)=>{
        const $target = e.target as HTMLElement
        if ($target.tagName === "H3") {
            $target.classList.toggle("opened")
        }
    })

    Fancybox.bind("[data-fancybox-group]", {
        // Your custom options
    });

});